import React, { useEffect, useState } from "react";
import ApiService from "../../../Services/user/service";
import Table from "../../../Utils/Table/Table";
import { set } from "date-fns";
import { Wallet, Coins, ArrowDownCircle, ArrowUpCircle, ArrowRightLeft } from "lucide-react";
import { toast } from "react-toastify";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
const PaymentHistory = () => {
  const currency = localStorage.getItem("currentCurrency");
  const userid = localStorage.getItem("user_id") || "User";
  const [payementdata, setPaymentdata] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userdetails, setUserdetails] = useState([]);
  const market = JSON.parse(localStorage.getItem("market")) ?? [];
  const [showModal, setShowModal] = useState(false);
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [depositModal, setDepositModal] = useState(false);
  const [depositAmount, setDepositAmount] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [receiptBase64, setReceiptBase64] = useState("");

  const [mode, setMode] = useState("USD");
  const [amount, setAmount] = useState("");
  const usdRate = 83.5; // fix rate

  const isUSD = mode === "USD";
  const inputIcon = isUSD ? "$" : "₹";
  const inputPlaceholder = isUSD ? "Enter USD Amount" : "Enter INR Amount";


  const convertedInr =
  currency !== "1" && depositAmount
    ? (Number(depositAmount) * usdRate).toFixed(2)
    : null;

  const convertedAmount = amount
    ? isUSD
      ? (amount * usdRate).toFixed(2)
      : (amount / usdRate).toFixed(2)
    : "0.00";


    const withdrawQuickAmounts =
  currency === "1"
    ? [5000, 10000, 25000]   // INR
    : [100, 500, 1000];     // USD

    const depositQuickAmounts =
  currency === "1"
    ? [500, 10000, 25000]   // INR
    : [100, 500, 1000];     // USD


  const openModal = (item) => {
    setSelectedPayment(item);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPayment(null);
  };

  const getpaymentHistoryUsd = async () => {
    try {
      const payload = {
        userid: userid,
      }
      const res = await ApiService.paymentHistory(payload);
      console.log("payemnt History", res.data.data);
      setPaymentdata(res.data.data);
    } catch {
      setPaymentdata([]);
    }
  };

  const getpaymentHistoryInr = async () => {
    try {
      const res = await ApiService.paymentHistoryInr({ userid });
    
      setPaymentdata(res.data.data);
    } catch {
      setPaymentdata([]);
    }
  };

  const fetchuserdetails = async () => {
    try {

      const res = await ApiService.getUserDetail(userid);

      setUserdetails(res.data.data[0]);
    } catch (err) {
      console.log(err)
    }
  }


  useEffect(() => {
    if (currency === "1") getpaymentHistoryInr();
    else getpaymentHistoryUsd();
  }, [currency, userid]);

  useEffect(() => {
    fetchuserdetails();
  }, [])


  let availableBalance = 0;
  let availableMargin = 0;

  if (userdetails && Object.keys(userdetails).length > 0) {

    // BALANCE CALCULATION
    if (currency === "1") {
      availableBalance =
        (userdetails.Inr_Balance || 0);
    } else {
      availableBalance =
        (userdetails.Balance || 0);
    }

    // MARGIN CALCULATION
    if (currency === "1") {
      availableMargin =
        (userdetails.Inr_Balance || 0) * (userdetails.limit || 1);
    } else {
      availableMargin =
        (userdetails.Balance || 0) * (userdetails.limit || 1);
    }
  }

  const handleSubmit = async () => {
    const rate = 83.5;

    let convertedValue = 0;

    if (mode === "USD") {
      // ✔️ USD → INR (multiply)
      convertedValue = Number(amount) * rate;
    } else {
      // ✔️ INR → USD (divide)
      convertedValue = Number(amount) / rate;
    }

    const payload = {
      userId: userid,
      from: mode,
      to: mode === "USD" ? "INR" : "USD",
      amount: Number(amount),           // original amount
      convertedAmount: convertedValue,  // final converted amount (frontend se)
    };

    console.log("Payload Sent:", payload);

    try {
      await ApiService.fundConverter(payload);
      toast("Conversion Successful");
      closeCurrencyModal();
      fetchuserdetails();

    } catch (err) {
      console.log(err);
      alert("Conversion Failed");
    }
  };



  const closeCurrencyModal = () => {
    setShowModal(false);
    setAmount("");
  };

  const handleWithdrawSubmit = async () => {
    if (!withdrawAmount || Number(withdrawAmount) <= 0) {
      toast.error("Enter valid withdraw amount");
      return;
    }

    if (Number(withdrawAmount) > availableBalance) {
      toast.error("Insufficient balance");
      return;
    }


    const payload = {
      userid: userid,
      Balance: Number(withdrawAmount),
      type: 0,
      transactionId: "",
      ScreenShot: "",
      governmentDocs: ""
    };

    console.log("Withdraw Payload:", payload);

    try {
      if (currency === "1") {
        await ApiService.withdrawalDepositInr(payload);
      } else {
        await ApiService.withdrawalDeposit(payload);
      }
      toast.success("Withdraw request submitted");
    } catch (err) {
      console.error(err);
      toast.error("Withdraw failed");
    } finally {
      // 🔥 YAHI MAIN FIX HAI
      setWithdrawModal(false);
      setWithdrawAmount("");

      console.log("Refreshing user details...");
      await fetchuserdetails();

      if (currency === "1") {
        await getpaymentHistoryInr();
      } else {
        await getpaymentHistoryUsd();
      }
    }
  };



  const handleDepositSubmit = async () => {
    if (!depositAmount || Number(depositAmount) <= 0) {
      toast.error("Enter valid deposit amount");
      return;
    }

    if (!transactionId) {
      toast.error("Enter transaction ID");
      return;
    }

    if (!receiptBase64) {
      toast.error("Upload payment receipt");
      return;
    }

    const payload = {
      userid: userid,
      Balance: Number(depositAmount),
      type: 1, // 1 = deposit
      transactionId: transactionId,
      ScreenShot: receiptBase64
    };

    console.log("Deposit Payload:", payload);

    try {
      if (currency === "1") {
        await ApiService.withdrawalDepositInr(payload);
      } else {
        await ApiService.withdrawalDeposit(payload);
      }
      toast.success("Deposit request submitted");
    } catch (err) {
      console.error(err);
      toast.error("Deposit failed");
    }finally {
  setDepositModal(false);
  setDepositAmount("");
  setTransactionId("");
  setReceiptBase64("");

  await fetchuserdetails();

  if (currency === "1") {
    await getpaymentHistoryInr();
  } else {
    await getpaymentHistoryUsd();
  }
}

  };



  const handleReceiptUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setReceiptBase64(reader.result); // base64
    };
    reader.readAsDataURL(file);
  };


  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <div>PaymentHistory</div>
          </div>
        </div>
        <div className="card-body">

          <div className="p-4 border rounded shadow-sm mb-4">

            <div className="d-flex justify-content-between align-items-center">

              {/* LEFT SIDE BALANCE + MARGIN */}
              <div className="d-flex gap-5">

                {/* AVAILABLE BALANCE */}
                <div>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <Wallet size={20} className="text-success" />
                    <h6 className="text-muted mb-0">Available Balance</h6>
                  </div>
                  <h2 className="fw-bold text-success">
                    ₹{(availableBalance || 0).toFixed(3)}
                  </h2>
                </div>

                {/* AVAILABLE MARGIN */}
                <div>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <Coins size={20} className="text-primary" />
                    <h6 className="text-muted mb-0">Available Margin</h6>
                  </div>
                  <h2 className="fw-bold text-primary">
                    ${(availableMargin || 0).toFixed(2)}
                  </h2>
                </div>

              </div>

              {/* RIGHT SIDE BUTTONS */}
              <div className="d-flex gap-3">

                {Array.isArray(market) && market.includes(0) && market.includes(1) && (

                  <span
                    onClick={() => setShowModal(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <ArrowRightLeft size={22} className="text-primary mt-2 me-4 " />
                  </span>
                )}

                <button
                  className="btn btn-success d-flex align-items-center gap-2 px-4 py-2 fw-semibold"
                  onClick={() => {
                    setDepositAmount("");
                    setDepositModal(true);
                  }}
                >
                  <ArrowDownCircle size={20} />
                  Deposit
                </button>


                <button
                  className="btn btn-danger d-flex align-items-center gap-2 px-4 py-2 fw-semibold"
                  onClick={() => {
                    setWithdrawAmount("");
                    setWithdrawModal(true);
                  }}
                >
                  <ArrowUpCircle size={20} />
                  Withdraw
                </button>


              </div>

            </div>

          </div>




          <h5 className="mb-3">Payment History</h5>

          {payementdata.length === 0 ? (
            <p className="text-muted">No payment history available.</p>
          ) : (
            payementdata.map((item, index) => (
              <div
                key={index}
                className="p-3 mb-3 border rounded d-flex justify-content-between align-items-center statement-card shadow-sm"
              >

                {/* LEFT SIDE — TYPE + DATE */}
                <div>

                  {/* TYPE: Withdraw / Deposit */}
                  <h6 className="fw-bold mb-1">
                    {item.type === 0 ? (
                      <span className="text-danger">Withdraw</span>
                    ) : (
                      <span className="text-success">Deposit</span>
                    )}
                  </h6>

                  {/* DATE */}
                  <small className="text-muted">
                    {fDateTimesec(item.createdAt)}
                  </small>
                </div>

                {/* CENTER — AMOUNT */}
                <div>
                  <span
                    className={`fw-bold ${item.type === 1 ? "text-success" : "text-danger"
                      }`}
                  >
                    {currency === "1" ? "₹" : "$"}{item.Balance}
                  </span>
                </div>

                {/* RIGHT — STATUS + EYE */}
                <div className="d-flex align-items-center gap-2">

                  {/* STATUS COLORS */}
                  {item.status === 0 ? (
                    /* Withdraw pending → Blue */
                    <span className="badge" style={{
                      background: "#007bff",
                      color: "#fff",
                      width: "90px",
                      padding: "5px"
                    }}>
                      Pending
                    </span>
                  ) : (
                    <>
                      <span className="badge bg-success">Completed <span
                        style={{ cursor: "pointer" }}
                        onClick={() => openModal(item)}
                      >
                        <i
                          className="fa fa-eye "

                        ></i>
                      </span></span>

                      {/* Eye icon */}

                    </>
                  )}
                </div>

              </div>
            ))
          )}
        </div>


      </div>

      {isModalOpen && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered " > 
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">Payment Details</h5>
                <button className="btn-close" onClick={closeModal}></button>
              </div>

             <div className="modal-body d-flex flex-column gap-3 px-4 py-3">

  <div className="d-flex align-items-center gap-3">
    <strong style={{ minWidth: "120px" }}>Type:</strong>
    <span>{selectedPayment.type === 0 ? "Withdraw" : "Deposit"}</span>
  </div>

  <div className="d-flex align-items-center gap-3">
    <strong style={{ minWidth: "120px" }}>Status:</strong>
    <span>{selectedPayment.status === 0 ? "Pending" : "Completed"}</span>
  </div>

  <div className="d-flex align-items-center gap-3">
    <strong style={{ minWidth: "120px" }}>Amount:</strong>
    <span>₹{selectedPayment.Balance}</span>
  </div>

  <div className="d-flex align-items-center gap-3">
    <strong style={{ minWidth: "120px" }}>Date:</strong>
    <span>{fDateTimesec(selectedPayment.createdAt)}</span>
  </div>

  <div className="d-flex align-items-center gap-3">
    <strong style={{ minWidth: "120px" }}>Transaction ID:</strong>
    <span>{selectedPayment.transactionId || "N/A"}</span>
  </div>

</div>

            </div>
          </div>
        </div>
      )}


      {showModal && (
        <div
          className="custom-modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="custom-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="custom-modal-header">
              <h5 className="m-0">Currency Converter</h5>
              <button className="close-btn" onClick={() => {
                setShowModal(false);
                setAmount("");
              }} >
                ×
              </button>
            </div>

            {/* BODY */}
            <div className="custom-modal-body">

              {/* SWITCH BUTTONS */}
              <div className="switch-segment">
                <div
                  className={`seg ${mode === "USD" ? "active" : ""}`}
                  onClick={() => {
                    setMode("USD");
                    setAmount("");  // IMPORTANT FIX
                  }}
                >
                  USD → INR
                </div>

                <div
                  className={`seg ${mode === "INR" ? "active" : ""}`}
                  onClick={() => {
                    setMode("INR");
                    setAmount("");  // IMPORTANT FIX
                  }}
                >
                  INR → USD
                </div>
              </div>

              {/* INPUT */}
              <div className="input-box">
                <span className="money-icon">{inputIcon}</span>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder={inputPlaceholder}
                />
              </div>

              {/* OUTPUT */}
              <div className="output-box">
                <label>Converted Amount</label>
                <h4>{convertedAmount}</h4>
              </div>

              {/* SUBMIT BTN */}
              <button className="submit-btn" onClick={handleSubmit}>
                Submit Conversion
              </button>

            </div>
          </div>
        </div>
      )}


      {withdrawModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              {/* HEADER */}
              <div className="modal-header">
                <h5 className="modal-title">Withdraw Funds</h5>
                <button
                  className="btn-close"
                  onClick={() => setWithdrawModal(false)}
                ></button>
              </div>

              {/* BODY */}
              <div className="modal-body">

                {/* AVAILABLE BALANCE */}
                <div className="mb-3">
                  <small className="text-muted">Available Balance</small>
                  <h5 className="fw-bold text-success">
                    {currency === "1" ? "₹" : "$"} {availableBalance.toFixed(2)}
                  </h5>
                </div>

                {/* INPUT */}
                <div className="mb-3">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter withdraw amount"
                    value={withdrawAmount}
                    onChange={(e) => setWithdrawAmount(e.target.value)}
                  />
                </div>

              
                {/* QUICK BUTTONS */}
<div className="d-flex justify-content-center gap-2 mb-3">
  {withdrawQuickAmounts.map((amt) => (
    <button
      key={amt}
      className="btn btn-outline-secondary btn-sm"
      onClick={() =>
        setWithdrawAmount(prev =>
          (Number(prev || 0) + amt).toString()
        )
      }
    >
      +{currency === "1" ? "₹" : "$"}{amt}
    </button>
  ))}
</div>



              </div>

              <button
                className="btn btn-danger w-80 my-3 mx-3 "
                onClick={handleWithdrawSubmit}
              >
                Submit Withdraw
              </button>


            </div>
          </div>
        </div>

      )}


      {depositModal && (
        <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              {/* HEADER */}
              <div className="modal-header">
                <h5 className="modal-title">Deposit Funds</h5>
                <button className="btn-close" onClick={() => setDepositModal(false)} />
              </div>

              {/* BODY */}
              <div className="modal-body">

               <div className="D-flex justify-content-between">
                 <div>
                  {/* AMOUNT INPUT */}
                <input
                  type="number"
                  className="form-control mb-3"
                  placeholder="Enter deposit amount"
                  value={depositAmount}
                  onChange={(e) => setDepositAmount(e.target.value)}
                />
                </div>

<div>
  {/* USD → INR PREVIEW */}
{currency !== "1" && depositAmount && (
  <div className="text-end mb-2">
    <small className="text-muted">
      ≈ ₹{convertedInr} INR
    </small>
  </div>
)}

</div>
               </div>



                {/* QUICK AMOUNT BUTTONS (⬇️ QR KE NICHE) */}
               <div className="d-flex justify-content-center gap-2 mb-3">
  {depositQuickAmounts.map((amt) => (
    <button
      key={amt}
      className="btn btn-outline-secondary btn-sm"
      onClick={() =>
        setDepositAmount(prev =>
          (Number(prev || 0) + amt).toString()
        )
      }
    >
      +{currency === "1" ? "₹" : "$"}{amt}
    </button>
  ))}
</div>




                {/* QR CODE */}
                <div className="text-center mb-3">
                  <img
                    src="/qr-code.png"   // backend/static QR
                    alt="QR Code"
                    style={{ width: 180 }}
                  />
                  <small className="text-muted d-block mt-1">
                    Scan & Pay
                  </small>
                </div>

                {/* RECEIPT UPLOAD */}
                <div className="mb-3">
                  <label className="form-label">Upload Payment Receipt</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleReceiptUpload}
                  />
                </div>

                {/* TRANSACTION ID */}
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Enter Transaction ID"
                  value={transactionId}
                  onChange={(e) => setTransactionId(e.target.value)}
                />

                {/* SUBMIT */}
                <button
                  className="btn btn-success w-100"
                  onClick={handleDepositSubmit}
                >
                  Submit Deposit
                </button>

              </div>

            </div>
          </div>
        </div>
      )}




    </div>
  );
};

export default PaymentHistory;
